export enum AppToastType {
	Info = 'info',
	Warning = 'warning',
}
